import { Types } from './../Models/POIModel';
// import { EnumTypes } from './../Models/EnumTypes/PageEnumTypes';
import * as POIActions from 'Redux/Actions/POIActions';
import * as POIConnector from './../Connectors/POIConnector';

export { Types, POIConnector as Connector, POIActions as Actions };



// WEBPACK FOOTER //
// ./src/Modules/POIModule.ts